import {
  readQueryParamNumber,
  readQueryParamString,
} from "/Helpers/readQueryParam";
import { SearchResultsProps } from "/Models/Generated/SearchResultsProps";

export default class SearchClient {
  constructor(
    private endpoint: string,
    private language: string,
    private searchPageId: number,
  ) {}

  public GetUrl = (
    pageNumber: number,
    term: string,
    sortByRelevance: boolean,
    fuzzy?: boolean,
    year?: number,
    categories?: string,
  ): string | null => {
    if (typeof window === "undefined") return null;
    const prefix = window.location.href.split("?")[0].split("#")[0];
    return (
      prefix +
      `?page=${pageNumber}&language=${this.language}&term=${term}&sortby=${
        sortByRelevance ? "relevance" : "date"
      }${fuzzy ? "&fuzzy=true" : ""}${year ? "&year=" + year : ""}${categories ? "&categories=" + categories : ""}`
    );
  };

  public GetItems = (
    pageNumber: number,
    term: string,
    sortByRelevance: boolean,
    fuzzy?: boolean,
    year?: number,
    categories?: string,
  ): Promise<SearchResultsProps> => {
    return fetch(
      `${this.endpoint}?page=${pageNumber}&language=${
        this.language
      }&term=${term}&sortby=${
        sortByRelevance ? "relevance" : "date"
      }&searchpageid=${this.searchPageId}${fuzzy ? "&fuzzy=true" : ""}${year ? "&year=" + year : ""}${categories ? "&categories=" + categories : ""}`,
    ).then((response) => {
      if (!response.ok) throw new Error("Error from search API");
      return response.json();
    });
  };

  public GetTermFromUrl = (): string => readQueryParamString("term") ?? "";

  public GetPageNumberFromUrl = (): number => readQueryParamNumber("page") ?? 1;

  public GetSortByRelevanceFromUrl = (): boolean =>
    readQueryParamString("sortby") !== "date";
}
